import { render, staticRenderFns } from "./PageCache.vue?vue&type=template&id=64c9f8e4&scoped=true"
import script from "./PageCache.vue?vue&type=script&lang=ts"
export * from "./PageCache.vue?vue&type=script&lang=ts"
import style0 from "./PageCache.vue?vue&type=style&index=0&id=64c9f8e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9f8e4",
  null
  
)

export default component.exports